export default __webpack_public_path__ + "static/media/coins.3f4843f5.svg";